// import { useState, useRef, useEffect } from 'react'
// import { useParams } from 'react-router-dom'
// import axios from 'axios'
// import {
//   Container,
//   Row,
//   Col,
//   ListGroup,
//   Form,
//   InputGroup,
//   Button,
//   Dropdown,
// } from 'react-bootstrap'
// import { Smile, Send, CheckCircle, Circle } from 'react-feather'
// import moment from 'moment'
// import EmojiPicker from 'emoji-picker-react'
// import Header from '../Components/Header'

// const ChatComponent = () => {
//   const { id } = useParams() // Get recipient ID from URL
//   const [recentChats, setRecentChats] = useState([])
//   const [messages, setMessages] = useState([])
//   const [messageInput, setMessageInput] = useState('')
//   const [showEmojiPicker, setShowEmojiPicker] = useState(false)
//   const [users, setUsers] = useState([])
//   const [selectedRecipient, setSelectedRecipient] = useState(null)
//   const chatContainerRef = useRef(null)
//   const token = localStorage.getItem('jwttoken')

//   // Fetch Users
//   useEffect(() => {
//     axios
//       .get('https://tdtlworld.com/dss-kaas-backend/socialapp/users/', {
//         headers: { Authorization: `Bearer ${token}` },
//       })
//       .then((response) => {
//         setUsers(response.data)
//       })
//       .catch((error) => console.error('Error fetching users:', error))
//   }, [token])

//   // Select Recipient from URL
//   useEffect(() => {
//     if (id && users.length > 0) {
//       const recipient = users.find((user) => user.user_id === parseInt(id))
//       if (recipient) setSelectedRecipient(recipient)
//     }
//   }, [id, users])

//   // Fetch Messages for Selected Recipient
//   useEffect(() => {
//     if (!selectedRecipient?.user_id) return

//     axios
//       .get(
//         `https://tdtlworld.com/dss-kaas-backend/socialapp/chat/${selectedRecipient.user_id}/`,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       )
//       .then((response) => {
//         setMessages(response.data)
//       })
//       .catch((error) => console.error('Error fetching chat messages:', error))
//   }, [selectedRecipient?.user_id])

//   // Mark Messages as Read
//   useEffect(() => {
//     const unreadMessages = messages.filter((msg) => !msg.is_read)

//     unreadMessages.forEach((msg) => {
//       axios
//         .post(
//           `https://tdtlworld.com/dss-kaas-backend/socialapp/messages/${msg.id}/read/`,
//           {},
//           {
//             headers: { Authorization: `Bearer ${token}` },
//           }
//         )
//         .then(() => {
//           setMessages((prevMessages) =>
//             prevMessages.map((m) =>
//               m.id === msg.id ? { ...m, is_read: true } : m
//             )
//           )
//         })
//         .catch((error) =>
//           console.error('Error marking message as read:', error)
//         )
//     })
//   }, [messages])

//   // Send Message
//   const sendMessage = () => {
//     if (!messageInput.trim() || !selectedRecipient?.user_id) return

//     const payload = {
//       receiver_id: selectedRecipient.user_id,
//       content: messageInput,
//     }

//     axios
//       .post('https://tdtlworld.com/dss-kaas-backend/socialapp/messages/send/', payload, {
//         headers: { Authorization: `Bearer ${token}` },
//       })
//       .then((response) => {
//         setMessages([...messages, response.data]) // Add new message to chat
//         setMessageInput('')
//       })
//       .catch((error) => console.error('Error sending message:', error))
//   }

//   return (
//     <div>
//       <Header />
//       <Container
//         className='shadow rounded p-3 bg-light'
//         style={{ height: '90vh', marginTop: '4.5rem' }}
//       >
//         <Row className='h-100'>
//           {/* User List Dropdown */}
//           <Col md={4} className='border-end bg-white p-3 overflow-auto'>
//             <h5>Select User</h5>
//             <Dropdown>
//               <Dropdown.Toggle variant='secondary' id='dropdown-users'>
//                 {selectedRecipient
//                   ? selectedRecipient.full_name
//                   : 'Choose a user'}
//               </Dropdown.Toggle>
//               <Dropdown.Menu>
//                 {users.map((user) => (
//                   <Dropdown.Item
//                     key={user.user_id}
//                     onClick={() => setSelectedRecipient(user)}
//                   >
//                     {user.full_name}
//                   </Dropdown.Item>
//                 ))}
//               </Dropdown.Menu>
//             </Dropdown>
//           </Col>

//           {/* Chat Window */}
//           <Col md={8} className='d-flex flex-column'>
//             {selectedRecipient && (
//               <div className='bg-success text-white p-2 text-center rounded-top fw-bold'>
//                 Chat with {selectedRecipient.full_name}
//               </div>
//             )}

//             <div className='flex-grow-1 overflow-auto p-3 bg-white border rounded'>
//               {messages.length > 0 ? (
//                 messages.map((msg, index) => (
//                   <div
//                     key={index}
//                     className={`d-flex mb-2 ${
//                       msg.sender === 'You'
//                         ? 'justify-content-end'
//                         : 'justify-content-start'
//                     }`}
//                   >
//                     <div
//                       className={`p-2 rounded shadow-sm ${
//                         msg.sender === 'You'
//                           ? 'bg-success text-white'
//                           : 'bg-light border'
//                       }`}
//                     >
//                       <p className='mb-1 fw-medium'>{msg.content}</p>
//                       <small className='text-muted'>
//                         {moment(msg.timestamp).format('h:mm A')}
//                       </small>
//                       {msg.is_read ? (
//                         <CheckCircle size={16} color='blue' className='ms-2' />
//                       ) : (
//                         <Circle size={16} color='red' className='ms-2' />
//                       )}
//                     </div>
//                   </div>
//                 ))
//               ) : (
//                 <p className='text-center text-muted'>No messages found</p>
//               )}
//             </div>

//             {/* Message Input */}
//             <div className='p-2 bg-white border-top d-flex align-items-center position-relative'>
//               <Button
//                 variant='light'
//                 onClick={() => setShowEmojiPicker(!showEmojiPicker)}
//               >
//                 <Smile size={24} />
//               </Button>
//               <InputGroup>
//                 <Form.Control
//                   type='text'
//                   placeholder='Write a message...'
//                   value={messageInput}
//                   onChange={(e) => setMessageInput(e.target.value)}
//                   onKeyDown={(e) => e.key === 'Enter' && sendMessage()}
//                 />
//               </InputGroup>
//               <Button variant='success' onClick={sendMessage}>
//                 <Send size={20} />
//               </Button>
//               {showEmojiPicker && (
//                 <div className='position-absolute bottom-100 start-0 mb-2 bg-white shadow-lg rounded p-2'>
//                   <EmojiPicker
//                     onEmojiClick={(emoji) =>
//                       setMessageInput((prev) => prev + emoji.emoji)
//                     }
//                   />
//                 </div>
//               )}
//             </div>
//           </Col>
//         </Row>
//       </Container>
//     </div>
//   )
// }

// export default ChatComponent

// import { useState, useRef, useEffect } from 'react'
// import { useParams } from 'react-router-dom'
// import axios from 'axios'
// import { MessageSquare } from 'react-feather';

// import {
//   Container,
//   Row,
//   Col,
//   ListGroup,
//   Form,
//   InputGroup,
//   Button,
//   Dropdown,
// } from 'react-bootstrap'
// import { Smile, Send, CheckCircle, Circle, User } from 'react-feather' // Added User icon
// import moment from 'moment'
// import EmojiPicker from 'emoji-picker-react'
// import Header from '../Components/Header' // Assuming this exists

// // It's better to put CSS in a separate file, but for this example,
// // I'll include it here for easier understanding.
// const ChatComponentStyles = `
//   .chat-app-container {
//     background: linear-gradient(135deg,rgb(149, 90, 226) 0%, #f7797d 100%); /* Blue to Pink gradient */
//     padding: 4.5rem;
//     border-radius: 15px;
//     height: calc(90vh - 1rem); /* Adjusted height */
//     margin-top: 5rem; /* Adjusted margin */
//     box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
//   }

//   .user-list-column {
//     background-color: rgba(255, 255, 255, 0.85);
//     border-radius: 10px 0 0 10px;
//     padding: 1.5rem;
//     display: flex;
//     flex-direction: column;
//   }

//   .user-list-column h5 {
//     color: #333;
//     margin-bottom: 1rem;
//     font-weight: 600;
//   }

//   .user-dropdown .dropdown-toggle {
//     background-color: #fff;
//     color: #555;
//     border: 1px solid #ddd;
//     width: 100%;
//     text-align: left;
//     display: flex;
//     justify-content: space-between;
//     align-items: center;
//   }
//    .user-dropdown .dropdown-toggle:hover, .user-dropdown .dropdown-toggle:focus {
//     background-color: #f8f9fa;
//     color: #333;
//    }

//   .user-dropdown .dropdown-menu {
//     width: 100%;
//     border: 1px solid #eee;
//     box-shadow: 0 4px 12px rgba(0,0,0,0.08);
//   }

//   .user-dropdown .dropdown-item {
//     color: #444;
//   }
//   .user-dropdown .dropdown-item:hover {
//     background-color: #e9ecef;
//   }


//   .chat-window-column {
//     background-color: rgba(255, 255, 255, 0.95);
//     border-radius: 0 10px 10px 0;
//     display: flex;
//     flex-direction: column;
//     padding: 0; /* Remove padding to allow children to fill */
//   }

//   .chat-header {
//     background: linear-gradient(to right, rgb(149, 90, 226), #e06c71); /* Subtler gradient for header */
//     color: white;
//     padding: 0.75rem 1.25rem;
//     font-weight: bold;
//     border-radius: 0 10px 0 0;
//     text-align: center;
//     font-size: 1.1rem;
//   }

//   .messages-area {
//     flex-grow: 1;
//     overflow-y: auto;
//     padding: 1.5rem;
//     background-color: transparent; /* Let chat-window-column background show */
//   }

//   /* Custom scrollbar for webkit browsers */
//   .messages-area::-webkit-scrollbar {
//     width: 8px;
//   }
//   .messages-area::-webkit-scrollbar-track {
//     background: rgba(0,0,0,0.05);
//     border-radius: 10px;
//   }
//   .messages-area::-webkit-scrollbar-thumb {
//     background: #f7797d; /* Pink accent */
//     border-radius: 10px;
//   }
//   .messages-area::-webkit-scrollbar-thumb:hover {
//     background: #e06c71;
//   }


//   .message-bubble {
//     padding: 0.6rem 1rem;
//     border-radius: 18px;
//     max-width: 70%;
//     word-wrap: break-word;
//     box-shadow: 0 2px 5px rgba(0,0,0,0.08);
//   }

//   .message-bubble p {
//     margin-bottom: 0.25rem;
//     font-size: 0.95rem;
//   }
//   .message-bubble small {
//     font-size: 0.75rem;
//   }

//   .sent-message {
//     background-color: #6dd5ed; /* Blue accent */
//     color: white;
//     border-bottom-right-radius: 5px !important;
//   }
//   .sent-message small {
//     color: rgba(255,255,255,0.8);
//   }
//   .sent-message .feather { /* Read receipt icons in sent messages */
//     color: #fff !important;
//   }


//   .received-message {
//     background-color: #e9ecef;
//     color: #333;
//     border: 1px solid #e0e0e0;
//     border-bottom-left-radius: 5px !important;
//   }
//    .received-message small {
//     color: #777;
//   }
//   .received-message .feather { /* Read receipt icons in received messages */
//     color: #6dd5ed !important; /* Blue check */
//   }


//   .message-input-area {
//     padding: 0.75rem 1rem;
//     background-color: #fff;
//     border-top: 1px solid #eee;
//     border-radius: 0 0 10px 0; /* Match chat window bottom-right */
//     display: flex;
//     align-items: center;
//   }

//   .message-input-area .form-control {
//     border-radius: 20px;
//     border: 1px solid #ddd;
//     padding: 0.5rem 1rem;
//   }
//   .message-input-area .form-control:focus {
//     border-color: #6dd5ed;
//     box-shadow: 0 0 0 0.2rem rgba(109, 213, 237, 0.25);
//   }

//   .message-input-area .btn {
//     border-radius: 50%;
//     width: 40px;
//     height: 40px;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     padding: 0;
//     margin-left: 0.5rem;
//   }
//   .message-input-area .btn-emoji {
//     background-color: transparent;
//     border: none;
//     color: #f7797d; /* Pink accent */
//   }
//    .message-input-area .btn-emoji:hover {
//      background-color: rgba(247, 121, 125, 0.1);
//    }

//   .message-input-area .btn-send {
//     background-color: #f7797d; /* Pink accent */
//     border-color: #f7797d;
//   }
//   .message-input-area .btn-send:hover {
//     background-color: #e06c71;
//     border-color: #e06c71;
//   }

//   .emoji-picker-container {
//     position: absolute;
//     bottom: 100%; /* Position above the input */
//     left: 0;
//     margin-bottom: 10px; /* Space from input */
//     z-index: 1000;
//     box-shadow: 0 5px 15px rgba(0,0,0,0.15);
//     border-radius: 8px;
//     overflow: hidden; /* To clip EmojiPicker's default border/shadow if any */
//   }
// `

// const ChatComponent = () => {
//   const { id } = useParams()
//   const [recentChats, setRecentChats] = useState([]) // Not used in current JSX, but kept for completeness
//   const [messages, setMessages] = useState([])
//   const [messageInput, setMessageInput] = useState('')
//   const [showEmojiPicker, setShowEmojiPicker] = useState(false)
//   const [users, setUsers] = useState([])
//   const [selectedRecipient, setSelectedRecipient] = useState(null)
//   const chatContainerRef = useRef(null)
//   const emojiPickerRef = useRef(null) // Ref for emoji picker
//   const token = localStorage.getItem('jwttoken')

//   // Inject styles
//   useEffect(() => {
//     const styleElement = document.createElement('style')
//     styleElement.innerHTML = ChatComponentStyles
//     document.head.appendChild(styleElement)
//     return () => {
//       document.head.removeChild(styleElement)
//     }
//   }, [])

//   // Fetch Users
//   useEffect(() => {
//     if (token) {
//       axios
//         .get('https://tdtlworld.com/dss-kaas-backend/socialapp/users/', {
//           headers: { Authorization: `Bearer ${token}` },
//         })
//         .then((response) => {
//           setUsers(response.data)
//         })
//         .catch((error) => console.error('Error fetching users:', error))
//     }
//   }, [token])

//   // Select Recipient from URL or first user if no ID
//   useEffect(() => {
//     if (users.length > 0) {
//       if (id) {
//         const recipientFromUrl = users.find((user) => user.user_id === parseInt(id))
//         if (recipientFromUrl) {
//           setSelectedRecipient(recipientFromUrl)
//         } else if (!selectedRecipient) {
//           // If ID is invalid and no recipient selected, pick first user
//           // setSelectedRecipient(users[0]);
//         }
//       } else if (!selectedRecipient) {
//         // If no ID and no recipient selected, optionally pick first user
//         // setSelectedRecipient(users[0]);
//       }
//     }
//   }, [id, users, selectedRecipient])


//   // Fetch Messages for Selected Recipient
//   useEffect(() => {
//     if (!selectedRecipient?.user_id || !token) return

//     axios
//       .get(
//         `https://tdtlworld.com/dss-kaas-backend/socialapp/chat/${selectedRecipient.user_id}/`,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       )
//       .then((response) => {
//         setMessages(response.data)
//       })
//       .catch((error) => console.error('Error fetching chat messages:', error))
//   }, [selectedRecipient?.user_id, token])

//   // Scroll to bottom when new messages arrive
//   useEffect(() => {
//     if (chatContainerRef.current) {
//       chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight
//     }
//   }, [messages])

//   // Mark Messages as Read
//   useEffect(() => {
//     if (!token) return;
//     const unreadMessages = messages.filter(
//       (msg) => !msg.is_read && msg.sender !== 'You' // Only mark received messages
//     )

//     if (unreadMessages.length > 0) {
//         unreadMessages.forEach((msg) => {
//         axios
//             .post(
//             `https://tdtlworld.com/dss-kaas-backend/socialapp/messages/${msg.id}/read/`,
//             {},
//             {
//                 headers: { Authorization: `Bearer ${token}` },
//             }
//             )
//             .then(() => {
//             setMessages((prevMessages) =>
//                 prevMessages.map((m) =>
//                 m.id === msg.id ? { ...m, is_read: true } : m
//                 )
//             )
//             })
//             .catch((error) =>
//             console.error('Error marking message as read:', error)
//             )
//         })
//     }
//   }, [messages, token]) // Added token dependency

//   // Send Message
//   const sendMessage = () => {
//     if (!messageInput.trim() || !selectedRecipient?.user_id || !token) return

//     const payload = {
//       receiver_id: selectedRecipient.user_id,
//       content: messageInput,
//     }

//     axios
//       .post('https://tdtlworld.com/dss-kaas-backend/socialapp/messages/send/', payload, {
//         headers: { Authorization: `Bearer ${token}` },
//       })
//       .then((response) => {
//         // Assuming the backend response for a sent message correctly identifies the sender or implies it's 'You'
//         const newMessage = { ...response.data, sender: 'You', is_read: false }; // Optimistic update
//         setMessages((prevMessages) => [...prevMessages, newMessage])
//         setMessageInput('')
//         setShowEmojiPicker(false) // Hide emoji picker on send
//       })
//       .catch((error) => console.error('Error sending message:', error))
//   }

//   // Handle clicks outside emoji picker to close it
//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (emojiPickerRef.current && !emojiPickerRef.current.contains(event.target)) {
//         // Check if the click was on the emoji toggle button itself
//         if (!event.target.closest('.btn-emoji')) {
//           setShowEmojiPicker(false);
//         }
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [emojiPickerRef]);


//   return (
//     <div>
//       <Header />
//       <Container fluid className='chat-app-container'>
//         <Row className='h-100'>
//           {/* User List Dropdown */}
//           <Col md={4} lg={3} className='user-list-column'>
//             <h5>Conversations</h5>
//             <Dropdown className="user-dropdown">
//               <Dropdown.Toggle variant="secondary" id='dropdown-users'>
//                 {selectedRecipient ? (
//                   <>
//                     <User size={18} className="me-2" /> {selectedRecipient.full_name}
//                   </>
//                 ) : 'Choose a user'}
//               </Dropdown.Toggle>
//               <Dropdown.Menu>
//                 {users.length > 0 ? (
//                   users.map((user) => (
//                     <Dropdown.Item
//                       key={user.user_id}
//                       onClick={() => {
//                         setSelectedRecipient(user)
//                         // Optionally, navigate to /chat/:id if you want URL to update
//                         // navigate(`/chat/${user.user_id}`);
//                       }}
//                       active={selectedRecipient?.user_id === user.user_id}
//                     >
//                       <User size={16} className="me-2" /> {user.full_name}
//                     </Dropdown.Item>
//                   ))
//                 ) : (
//                   <Dropdown.Item disabled>Loading users...</Dropdown.Item>
//                 )}
//               </Dropdown.Menu>
//             </Dropdown>
//             {/* You could list recent chats here later */}
//           </Col>

//           {/* Chat Window */}
//           <Col md={8} lg={9} className='chat-window-column'>
//             {selectedRecipient ? (
//               <>
//                 <div className='chat-header'>
//                   Chat with {selectedRecipient.full_name}
//                 </div>

//                 <div ref={chatContainerRef} className='messages-area'>
//                   {messages.length > 0 ? (
//                     messages.map((msg, index) => (
//                       <div
//                         key={msg.id || index} // Prefer msg.id if available and unique
//                         className={`d-flex mb-3 ${
//                           msg.sender === 'You' // Ensure backend provides this or logic to determine it
//                             ? 'justify-content-end'
//                             : 'justify-content-start'
//                         }`}
//                       >
//                         <div
//                           className={`message-bubble ${
//                             msg.sender === 'You'
//                               ? 'sent-message'
//                               : 'received-message'
//                           }`}
//                         >
//                           <p className='mb-1'>{msg.content}</p>
//                           <div className="d-flex align-items-center justify-content-end">
//                             <small className='me-2'>
//                               {moment(msg.timestamp).format('h:mm A')}
//                             </small>
//                             {msg.sender === 'You' && ( // Only show read status for sent messages
//                                 msg.is_read ? (
//                                 <CheckCircle size={14} />
//                                 ) : (
//                                 <Circle size={14} />
//                                 )
//                             )}
//                           </div>
//                         </div>
//                       </div>
//                     ))
//                   ) : (
//                     <p className='text-center text-muted mt-3'>
//                       No messages yet. Start the conversation!
//                     </p>
//                   )}
//                 </div>

//                 {/* Message Input */}
//                 <div className='message-input-area position-relative'>
//                    {showEmojiPicker && (
//                     <div className='emoji-picker-container' ref={emojiPickerRef}>
//                       <EmojiPicker
//                         onEmojiClick={(emojiData) => // Updated to emojiData for v4+
//                           setMessageInput((prev) => prev + emojiData.emoji)
//                         }
//                         emojiStyle="native" // Or your preferred style
//                         height={350}
//                         width="100%"
//                       />
//                     </div>
//                   )}
//                   <Button
//                     variant='light'
//                     className="btn-emoji me-2"
//                     onClick={() => setShowEmojiPicker(!showEmojiPicker)}
//                   >
//                     <Smile size={22} />
//                   </Button>
//                   <InputGroup>
//                     <Form.Control
//                       type='text'
//                       placeholder='Type your message...'
//                       value={messageInput}
//                       onChange={(e) => setMessageInput(e.target.value)}
//                       onKeyDown={(e) => {
//                         if (e.key === 'Enter' && !e.shiftKey) {
//                           e.preventDefault(); // Prevents newline in input
//                           sendMessage();
//                         }
//                       }}
//                     />
//                   </InputGroup>
//                   <Button className="btn-send" onClick={sendMessage} disabled={!messageInput.trim()}>
//                     <Send size={18} />
//                   </Button>
//                 </div>
//               </>
//             ) : (
//               <div className='d-flex flex-column justify-content-center align-items-center h-100 text-muted'>
//                 <MessageSquare size={64} className="mb-3" /> {/* Example Icon */}
//                 <h4>Select a user to start chatting</h4>
//                 <p>Choose a conversation from the list on the left.</p>
//               </div>
//             )}
//           </Col>
//         </Row>
//       </Container>
//     </div>
//   )
// }
// // You might need to import MessageSquare if you use it.


// export default ChatComponent
import { useState, useRef, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { MessageSquare } from 'react-feather';

import {
  Container,
  Row,
  Col,
  Form,
  InputGroup,
  Button,
  Dropdown,
  Spinner, // Added Spinner for loading states
} from 'react-bootstrap';
import { Smile, Send, CheckCircle, Circle, User } from 'react-feather';
import moment from 'moment';
import EmojiPicker from 'emoji-picker-react';
import Header from '../Components/Header'; // Assuming this exists

// It's better to put CSS in a separate file, but for this example,
// I'll include it here for easier understanding.
const ChatComponentStyles = `
  .chat-app-container {
    background: linear-gradient(135deg,rgb(149, 90, 226) 0%, #f7797d 100%); /* Blue to Pink gradient */
    padding: 4.5rem;
    border-radius: 15px;
    height: calc(90vh - 1rem); /* Adjusted height */
    margin-top: 5rem; /* Adjusted margin */
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  }

  .user-list-column {
    background-color: rgba(255, 255, 255, 0.85);
    border-radius: 10px 0 0 10px;
    padding: 1.5rem;
    display: flex;
    flex-direction: column;
  }

  .user-list-column h5 {
    color: #333;
    margin-bottom: 1rem;
    font-weight: 600;
  }

  .user-dropdown .dropdown-toggle {
    background-color: #fff;
    color: #555;
    border: 1px solid #ddd;
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
   .user-dropdown .dropdown-toggle:hover, .user-dropdown .dropdown-toggle:focus {
    background-color: #f8f9fa;
    color: #333;
   }
   .user-dropdown .dropdown-toggle:disabled {
    background-color: #e9ecef;
    opacity: 0.7;
   }

  .user-dropdown .dropdown-menu {
    width: 100%;
    border: 1px solid #eee;
    box-shadow: 0 4px 12px rgba(0,0,0,0.08);
  }

  .user-dropdown .dropdown-item {
    color: #444;
  }
  .user-dropdown .dropdown-item:hover {
    background-color: #e9ecef;
  }


  .chat-window-column {
    background-color: rgba(255, 255, 255, 0.95);
    border-radius: 0 10px 10px 0;
    display: flex;
    flex-direction: column;
    padding: 0; /* Remove padding to allow children to fill */
    position: relative; /* For centering loader */
  }

  .chat-header {
    background: linear-gradient(to right, rgb(149, 90, 226), #e06c71); /* Subtler gradient for header */
    color: white;
    padding: 0.75rem 1.25rem;
    font-weight: bold;
    border-radius: 0 10px 0 0;
    text-align: center;
    font-size: 1.1rem;
  }

  .messages-area {
    flex-grow: 1;
    overflow-y: auto;
    padding: 1.5rem;
    background-color: transparent; /* Let chat-window-column background show */
    position: relative; /* For centering loader if needed inside */
  }

  .loader-overlay { /* Centering loader in messages area or chat window */
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.5); /* Optional: slight overlay */
    z-index: 10;
    border-radius: 0 10px 10px 0; /* Match parent if it's in chat-window-column */
  }
  .messages-area .loader-overlay { /* Specific for messages area if needed */
    border-radius: 0;
  }


  /* Custom scrollbar for webkit browsers */
  .messages-area::-webkit-scrollbar {
    width: 8px;
  }
  .messages-area::-webkit-scrollbar-track {
    background: rgba(0,0,0,0.05);
    border-radius: 10px;
  }
  .messages-area::-webkit-scrollbar-thumb {
    background: #f7797d; /* Pink accent */
    border-radius: 10px;
  }
  .messages-area::-webkit-scrollbar-thumb:hover {
    background: #e06c71;
  }


  .message-bubble {
    padding: 0.6rem 1rem;
    border-radius: 18px;
    max-width: 70%;
    word-wrap: break-word;
    box-shadow: 0 2px 5px rgba(0,0,0,0.08);
  }

  .message-bubble p {
    margin-bottom: 0.25rem;
    font-size: 0.95rem;
  }
  .message-bubble small {
    font-size: 0.75rem;
  }

  .sent-message {
    background-color: #6dd5ed; /* Blue accent */
    color: white;
    border-bottom-right-radius: 5px !important;
  }
  .sent-message small {
    color: rgba(255,255,255,0.8);
  }
  .sent-message .feather { /* Read receipt icons in sent messages */
    color: #fff !important;
  }


  .received-message {
    background-color: #e9ecef;
    color: #333;
    border: 1px solid #e0e0e0;
    border-bottom-left-radius: 5px !important;
  }
   .received-message small {
    color: #777;
  }
  .received-message .feather { /* Read receipt icons in received messages */
    color: #6dd5ed !important; /* Blue check */
  }


  .message-input-area {
    padding: 0.75rem 1rem;
    background-color: #fff;
    border-top: 1px solid #eee;
    border-radius: 0 0 10px 0; /* Match chat window bottom-right */
    display: flex;
    align-items: center;
  }

  .message-input-area .form-control {
    border-radius: 20px;
    border: 1px solid #ddd;
    padding: 0.5rem 1rem;
  }
  .message-input-area .form-control:focus {
    border-color: #6dd5ed;
    box-shadow: 0 0 0 0.2rem rgba(109, 213, 237, 0.25);
  }
  .message-input-area .form-control:disabled {
    background-color: #f8f9fa;
  }


  .message-input-area .btn {
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    margin-left: 0.5rem;
  }
  .message-input-area .btn-emoji {
    background-color: transparent;
    border: none;
    color: #f7797d; /* Pink accent */
  }
   .message-input-area .btn-emoji:hover {
     background-color: rgba(247, 121, 125, 0.1);
   }
   .message-input-area .btn-emoji:disabled {
     color: #fbc1c3;
     background-color: transparent;
   }


  .message-input-area .btn-send {
    background-color: #f7797d; /* Pink accent */
    border-color: #f7797d;
  }
  .message-input-area .btn-send:hover {
    background-color: #e06c71;
    border-color: #e06c71;
  }
  .message-input-area .btn-send:disabled { /* Style for disabled send button */
    background-color: #fbc1c3;
    border-color: #fbc1c3;
    opacity: 0.65;
  }


  .emoji-picker-container {
    position: absolute;
    bottom: 100%; /* Position above the input */
    left: 0;
    margin-bottom: 10px; /* Space from input */
    z-index: 1000;
    box-shadow: 0 5px 15px rgba(0,0,0,0.15);
    border-radius: 8px;
    overflow: hidden; /* To clip EmojiPicker's default border/shadow if any */
  }
`;

const ChatComponent = () => {
  const { id } = useParams();
  const [messages, setMessages] = useState([]);
  const [messageInput, setMessageInput] = useState('');
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [users, setUsers] = useState([]);
  const [selectedRecipient, setSelectedRecipient] = useState(null);
  const chatContainerRef = useRef(null);
  const emojiPickerRef = useRef(null);
  const token = localStorage.getItem('jwttoken');

  // Loading states
  const [usersLoading, setUsersLoading] = useState(true);
  const [messagesLoading, setMessagesLoading] = useState(false);
  const [sendingMessage, setSendingMessage] = useState(false);

  // Inject styles
  useEffect(() => {
    const styleElement = document.createElement('style');
    styleElement.innerHTML = ChatComponentStyles;
    document.head.appendChild(styleElement);
    return () => {
      document.head.removeChild(styleElement);
    };
  }, []);

  // Fetch Users
  useEffect(() => {
    if (token) {
      setUsersLoading(true);
      axios
        .get('https://tdtlworld.com/dss-kaas-backend/socialapp/users/', {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          setUsers(response.data);
        })
        .catch((error) => {
          console.error('Error fetching users:', error);
          setUsers([]);
        })
        .finally(() => {
          setUsersLoading(false);
        });
    } else {
      setUsersLoading(false);
      setUsers([]);
      console.warn('No JWT token found. Users cannot be fetched.');
    }
  }, [token]);

  useEffect(() => {
    if (users.length > 0 && !usersLoading) {
      if (id) {
        const recipientFromUrl = users.find((user) => user.user_id === parseInt(id));
        if (recipientFromUrl) {
          if (selectedRecipient?.user_id !== recipientFromUrl.user_id) {
            setSelectedRecipient(recipientFromUrl);
          }
        } else {
          // Invalid ID in URL, clear selection or select default
           console.warn(`User with ID ${id} not found.`)
          // setSelectedRecipient(null); // Or users[0] if you want a default
        }
      } else if (!selectedRecipient && users.length > 0) {
        // No ID in URL and no recipient selected, optionally select first user
        // setSelectedRecipient(users[0]);
      }
    }
  }, [id, users, usersLoading, selectedRecipient]);


  // Fetch Messages for Selected Recipient
  useEffect(() => {
    if (!selectedRecipient?.user_id || !token) {
      setMessages([]);
      return;
    }

    setMessagesLoading(true);
    setMessages([]); // Clear previous messages
    axios
      .get(
        `https://tdtlworld.com/dss-kaas-backend/socialapp/chat/${selectedRecipient.user_id}/`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((response) => {
        setMessages(response.data);
      })
      .catch((error) => {
        console.error('Error fetching chat messages:', error);
        setMessages([]);
      })
      .finally(() => {
        setMessagesLoading(false);
      });
  }, [selectedRecipient?.user_id, token]);

  // Scroll to bottom when new messages arrive or loading finishes
  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
    }
  }, [messages, messagesLoading]);

  // Mark Messages as Read
  useEffect(() => {
    if (!token || !selectedRecipient) return;

    // Ensure your message object has `sender_id` if you use it for filtering
    // Otherwise, `msg.sender !== 'You'` is a good fallback.
    const unreadMessages = messages.filter(
      (msg) => !msg.is_read && msg.sender !== 'You' // && msg.sender_id === selectedRecipient.user_id
    );

    if (unreadMessages.length > 0) {
      unreadMessages.forEach((msg) => {
        axios
          .post(
            `https://tdtlworld.com/dss-kaas-backend/socialapp/messages/${msg.id}/read/`,
            {},
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          )
          .then(() => {
            setMessages((prevMessages) =>
              prevMessages.map((m) =>
                m.id === msg.id ? { ...m, is_read: true } : m
              )
            );
          })
          .catch((error) =>
            console.error('Error marking message as read:', error)
          );
      });
    }
  }, [messages, token, selectedRecipient]);

  // Send Message
  const sendMessage = () => {
    if (!messageInput.trim() || !selectedRecipient?.user_id || !token || sendingMessage) return;

    setSendingMessage(true);
    const tempMessageId = `temp-${Date.now()}`; // For optimistic update key
    const optimisticMessage = {
        id: tempMessageId, // Temporary ID for React key
        content: messageInput,
        sender: 'You',
        receiver_id: selectedRecipient.user_id,
        timestamp: new Date().toISOString(),
        is_read: false,
        // Add sender_id if your backend expects/returns it for 'You' messages
        // sender_id: myUserId, // You'd need to get the current user's ID
    };

    // Optimistic update
    setMessages((prevMessages) => [...prevMessages, optimisticMessage]);
    const currentMessageInput = messageInput; // Store current input
    setMessageInput('');
    setShowEmojiPicker(false);

    const payload = {
      receiver_id: selectedRecipient.user_id,
      content: currentMessageInput,
    };

    axios
      .post('https://tdtlworld.com/dss-kaas-backend/socialapp/messages/send/', payload, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        // Replace optimistic message with actual message from server
        setMessages((prevMessages) =>
            prevMessages.map((msg) =>
                msg.id === tempMessageId ? { ...response.data, sender: 'You', is_read: false } : msg
            )
        );
      })
      .catch((error) => {
        console.error('Error sending message:', error);
        // Revert optimistic update or show error
        setMessages((prevMessages) => prevMessages.filter(msg => msg.id !== tempMessageId));
        setMessageInput(currentMessageInput); // Restore input
        // Optionally, show an error toast to the user
      })
      .finally(() => {
        setSendingMessage(false);
      });
  };

  // Handle clicks outside emoji picker to close it
  useEffect(() => {
    function handleClickOutside(event) {
      if (emojiPickerRef.current && !emojiPickerRef.current.contains(event.target)) {
        if (!event.target.closest('.btn-emoji')) {
          setShowEmojiPicker(false);
        }
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [emojiPickerRef]);


  return (
    <div>
      <Header />
      <Container fluid className='chat-app-container'>
        <Row className='h-100'>
          {/* User List Dropdown */}
          <Col md={4} lg={3} className='user-list-column'>
            <h5>Conversations</h5>
            <Dropdown className="user-dropdown">
              <Dropdown.Toggle variant="secondary" id='dropdown-users' disabled={usersLoading}>
                {usersLoading ? 'Loading users...' : (selectedRecipient ? (
                  <>
                    <User size={18} className="me-2" /> {selectedRecipient.full_name}
                  </>
                ) : 'Choose a user')}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {usersLoading ? (
                  <Dropdown.ItemText className="text-center">
                    <Spinner animation="border" size="sm" /> Loading...
                  </Dropdown.ItemText>
                ) : users.length > 0 ? (
                  users.map((user) => (
                    <Dropdown.Item
                      key={user.user_id}
                      onClick={() => {
                        if (selectedRecipient?.user_id !== user.user_id) {
                            setSelectedRecipient(user);
                            // setMessages([]); // Cleared by useEffect for selectedRecipient
                        }
                        // navigate(`/chat/${user.user_id}`); // If using react-router navigation
                      }}
                      active={selectedRecipient?.user_id === user.user_id}
                    >
                      <User size={16} className="me-2" /> {user.full_name}
                    </Dropdown.Item>
                  ))
                ) : (
                  <Dropdown.Item disabled>No users available.</Dropdown.Item>
                )}
              </Dropdown.Menu>
            </Dropdown>
            {/* You could list recent chats here (e.g., users with last message snippet) */}
          </Col>

          {/* Chat Window */}
          <Col md={8} lg={9} className='chat-window-column'>
            {selectedRecipient ? (
              <>
                <div className='chat-header'>
                  Chat with {selectedRecipient.full_name}
                </div>

                <div ref={chatContainerRef} className='messages-area'>
                  {messagesLoading && (
                    <div className="loader-overlay">
                      <Spinner animation="border" variant="primary" />
                    </div>
                  )}
                  {!messagesLoading && messages.length > 0 ? (
                    messages.map((msg, index) => (
                      <div
                        key={msg.id || index} // Use msg.id, fallback to index if id is not unique initially
                        className={`d-flex mb-3 ${
                          msg.sender === 'You' // Ensure backend provides this or logic to determine it
                            ? 'justify-content-end'
                            : 'justify-content-start'
                        }`}
                      >
                        <div
                          className={`message-bubble ${
                            msg.sender === 'You'
                              ? 'sent-message'
                              : 'received-message'
                          }`}
                        >
                          <p className='mb-1'>{msg.content}</p>
                          <div className="d-flex align-items-center justify-content-end">
                            <small className='me-2'>
                              {moment(msg.timestamp).format('h:mm A')}
                            </small>
                            {msg.sender === 'You' && ( // Only show read status for sent messages
                                msg.is_read ? (
                                <CheckCircle size={14} /> // Read
                                ) : (
                                <Circle size={14} /> // Sent, not yet read (or Check for just delivered)
                                )
                            )}
                          </div>
                        </div>
                      </div>
                    ))
                  ) : !messagesLoading && messages.length === 0 ? (
                    <p className='text-center text-muted mt-3'>
                      No messages yet. Start the conversation!
                    </p>
                  ) : null /* Handles case where messagesLoading is true */}
                </div>

                {/* Message Input */}
                <div className='message-input-area position-relative'>
                   {showEmojiPicker && (
                    <div className='emoji-picker-container' ref={emojiPickerRef}>
                      <EmojiPicker
                        onEmojiClick={(emojiData) =>
                          setMessageInput((prev) => prev + emojiData.emoji)
                        }
                        emojiStyle="native"
                        height={350}
                        width="100%"
                      />
                    </div>
                  )}
                  <Button
                    variant='light'
                    className="btn-emoji me-2"
                    onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                    disabled={sendingMessage}
                  >
                    <Smile size={22} />
                  </Button>
                  <InputGroup>
                    <Form.Control
                      type='text'
                      placeholder='Type your message...'
                      value={messageInput}
                      onChange={(e) => setMessageInput(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' && !e.shiftKey) {
                          e.preventDefault();
                          sendMessage();
                        }
                      }}
                      disabled={sendingMessage}
                    />
                  </InputGroup>
                  <Button
                    className="btn-send"
                    onClick={sendMessage}
                    disabled={!messageInput.trim() || sendingMessage}
                  >
                    {sendingMessage ? (
                      <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                    ) : (
                      <Send size={18} />
                    )}
                  </Button>
                </div>
              </>
            ) : (
              <div className='d-flex flex-column justify-content-center align-items-center h-100 text-muted'>
                 {usersLoading ? (
                    <>
                      <Spinner animation="border" variant="secondary" className="mb-3" style={{width: '3rem', height: '3rem'}}/>
                      <h4>Loading conversations...</h4>
                    </>
                 ) : (
                    <>
                        <MessageSquare size={64} className="mb-3" />
                        <h4>Select a user to start chatting</h4>
                        <p>Choose a conversation from the list on the left.</p>
                    </>
                 )}
              </div>
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ChatComponent;
